module.exports = __webpack_public_path__ + "static/media/Sharp-LQ156T3LW03-Mechanical-Drawing.ca8d190e.gif";